<template>
  <div class="app-container">
    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-input v-model="listQuery.order_no" placeholder="订单号" class="filter-item" style="width: 250px;" clearable />

      <el-input v-model="listQuery.catered_product_id" placeholder="包餐产品ID" class="filter-item" style="width: 250px;" clearable />

      <el-input v-model="listQuery.name" placeholder="姓名" class="filter-item" style="width: 250px;" clearable />

      <el-input v-model="listQuery.major" placeholder="专业" class="filter-item" style="width: 250px;" clearable />

      <el-input v-model="listQuery.class" placeholder="班级" class="filter-item" style="width: 250px;" clearable />

      <el-input v-model="listQuery.identity_card" placeholder="身份证号" class="filter-item" style="width: 250px;" clearable />

      <el-input v-model="listQuery.phone" placeholder="手机号码" class="filter-item" style="width: 250px;" clearable />

      <el-select v-model="listQuery.split_order_status" placeholder="分账订单状态" class="filter-item" style="width: 140px;" clearable>
        <el-option label="无需分账" :value="0" />
        <el-option label="待分账" :value="1" />
        <el-option label="分账中" :value="2" />
        <el-option label="分账完成" :value="3" />
        <el-option label="分账失败" :value="4" />
      </el-select>

      <el-select v-model="listQuery.is_finish_split" placeholder="是否完结分账" class="filter-item" style="width: 140px;" clearable>
        <el-option label="未完结分账" :value="0" />
        <el-option label="已完结分账" :value="1" />
      </el-select>

      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button type="primary" class="filter-item" @click="handleFilter">搜索</el-button>

      <download-excel :fields="json_fields" :fetch="handleExport" type="xls" name="包餐产品订单.xls" worksheet="包餐产品订单">
        <el-button type="success" :loading="exportLoading">导出</el-button>
      </download-excel>
    </div>

    <div v-loading="listLoading" style="margin-bottom: 20px;">
      <el-row :gutter="20">
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payMoney || 0 }}</div>
            <div class="subtitle">累计消费金额</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payCount || 0 }}</div>
            <div class="subtitle">累计消费次数</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div style="margin-bottom: 20px;">
      <span style="font-size:18px;margin-left:30px;">分账总额：{{ledgerMoney}}</span>
      <span style="font-size:18px;margin-left:30px;" v-for="(item,index) in ledgerRole" :key="index">{{item.role_name}}：{{item.ledger_role_money}}</span>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <el-table-column label="分账单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.split_order_no }}
        </template>
      </el-table-column>

      <el-table-column label="姓名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.name }}
        </template>
      </el-table-column>

      <el-table-column label="性别" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.user.gender === 0" type="info">未设置</el-tag>
          <el-tag v-else-if="scope.row.user.gender === 1" type="primary">男</el-tag>
          <el-tag v-else-if="scope.row.user.gender === 2" type="danger">女</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="专业" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.major }}
        </template>
      </el-table-column>

      <el-table-column label="班级" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.class }}
        </template>
      </el-table-column>

      <el-table-column label="身份证号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.identity_card }}
        </template>
      </el-table-column>

      <el-table-column label="手机号码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user.phone }}
        </template>
      </el-table-column>

      <el-table-column label="包餐套餐名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.catered_product_snap.name }}
        </template>
      </el-table-column>

      <el-table-column label="开始日期" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.catered_product_snap.start_date }}
        </template>
      </el-table-column>

      <el-table-column label="结束日期" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.catered_product_snap.end_date }}
        </template>
      </el-table-column>

      <el-table-column label="早餐次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.catered_product_snap.breakfast_num }}
        </template>
      </el-table-column>

      <el-table-column label="午餐次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.catered_product_snap.lunch_num }}
        </template>
      </el-table-column>

      <el-table-column label="晚餐次数" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.catered_product_snap.dinner_num }}
        </template>
      </el-table-column>

      <el-table-column label="支付状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.pay_status === 0">待支付</el-tag>
          <el-tag type="success" v-else-if="scope.row.pay_status === 1">已支付</el-tag>
          <el-tag type="danger" v-else-if="scope.row.pay_status === 2">已取消</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="支付金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_money }}
        </template>
      </el-table-column>

      <el-table-column label="支付时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.pay_time }}
        </template>
      </el-table-column>

      <el-table-column label="分账订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.split_order_status === 0">无需分账</el-tag>
          <el-tag type="info" v-else-if="scope.row.split_order_status === 1">待分账</el-tag>
          <el-tag type="warning" v-else-if="scope.row.split_order_status === 2">分账中</el-tag>
          <el-tag type="success" v-else-if="scope.row.split_order_status === 3">分账完成</el-tag>
          <el-tag type="danger" v-else-if="scope.row.split_order_status === 4">分账失败</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="分账错误原因" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.split_order_status === 4 ? scope.row.split_error_msg : "" }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="250" align="center" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="handleCateredProductOrderSplitLog(scope.row)">分账收入记录</el-button>

          <el-button type="warning" size="mini" @click="handleCateredProductOrderFinishSplit(scope.row)" :disabled="(scope.row.split_order_status !== 0 && scope.row.split_order_status !== 4) || scope.row.is_finish_split === 1 || !scope.row.sub_mch_id">完结分账</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5, 10, 20, 30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
import downloadExcel from "vue-json-excel";
var moment = require("moment");

export default {
  components: {
    downloadExcel
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        school_id: "",
        order_no: "",
        catered_product_id: "",
        name: "",
        major: "",
        class: "",
        identity_card: "",
        phone: "",
        split_order_status: "",
        is_finish_split: "",
        start_date: "",
        end_date: "",
      },
      dateArr: null,
      ledgerMoney: null,
      ledgerRole: null,
      payMoney: null,
      payCount: null,
      json_fields: {
        订单号: {
          field: "order_no",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        分账单号: {
          field: "split_order_no",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        姓名: "user.name",
        性别: {
          field: "user.gender",
          callback: (value) => {
            if (value === 0) return "未设置";
            else if (value === 1) return "男";
            else if (value === 2) return "女";
            else return "";
          }
        },
        专业: "user.major",
        班级: "user.class",
        身份证号: {
          field: "user.identity_card",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        手机号码: {
          field: "user.phone",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        包餐套餐名: "catered_product_snap.name",
        开始日期: {
          field: "catered_product_snap.start_date",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        结束日期: {
          field: "catered_product_snap.end_date",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        早餐次数: "catered_product_snap.breakfast_num",
        午餐次数: "catered_product_snap.lunch_num",
        晚餐次数: "catered_product_snap.dinner_num",

        支付状态: {
          field: "pay_status",
          callback: (value) => {
            if (value === 0) return "待支付";
            else if (value === 1) return "已支付";
            else if (value === 2) return "已取消";
            else return "";
          }
        },
        支付金额: "pay_money",
        支付时间: {
          field: "pay_time",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        分账订单状态: {
          field: "split_order_status",
          callback: (value) => {
            if (value === 0) return "无需分账";
            else if (value === 1) return "待分账";
            else if (value === 2) return "分账中";
            else if (value === 3) return "分账完成";
            else if (value === 4) return "分账失败";
            else return "";
          }
        },
        分账错误原因: "split_error_msg",
      },
      exportLoading: false,
    };
  },
  created() {
    if (this.$route.query.catered_product_id) {
      this.listQuery.catered_product_id = this.$route.query.catered_product_id-0;
    }
    this.listQuery.start_date = moment().format("YYYY-MM-DD");
    this.listQuery.end_date = moment().format("YYYY-MM-DD");
    this.dateArr = [this.listQuery.start_date, this.listQuery.end_date];
    this.getList();
  },
  computed: {
    ...mapGetters(["schools", "school_id", "user"])
  },
  watch: {
    school_id(newVal, oldVal) {
      this.listQuery.school_id = newVal;
      this.getList();
    },
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_date = newVal[0];
        this.listQuery.end_date = newVal[1];
      } else {
        this.listQuery.start_date = "";
        this.listQuery.end_date = "";
      }
    }
  },
  methods: {
    getList() {
      this.listQuery.school_id = this.school_id;
      this.listLoading = true;
      request({
        url: "/api/backend/cateredProductOrder/list",
        method: "get",
        params: this.listQuery,
        timeout: 6000000,
      }).then((response) => {
        this.list = response.data.list.data;
        this.total = response.data.list.total;
        this.ledgerMoney = response.data.ledgerMoney;
        this.ledgerRole = response.data.ledgerRole;
        this.payMoney = response.data.payMoney;
        this.payCount = response.data.payCount;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCateredProductOrderSplitLog(item) {
      this.$router.push(`/catered/cateredProductOrderSplitLog?order_no=${item.order_no}`);
    },
    handleCateredProductOrderFinishSplit(item){
      request({
        url: "/api/backend/cateredProductOrder/finishSplit",
        method: "post",
        data: {
          order_no: item.order_no
        }
      }).then(() => {
        this.$message({
          type: "success",
          message: "操作成功!"
        });
        this.getList();
      });
    },
    handleExport() {
      if (!this.listQuery.start_date || !this.listQuery.end_date) {
        this.$message({
          type: "warning",
          message: "请选择时间段"
        });
        return;
      }

      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.page = 1;
      listQuery.limit = this.total;
      this.exportLoading = true;
      return request({
        url: "/api/backend/cateredProductOrder/list",
        method: "get",
        params: listQuery,
        timeout: 6000000,
      }).then(response => {
        if (response.data.list.data.length <= 0) {
          this.$message({
            type: "warning",
            message: "暂无记录"
          });
          return;
        }
        return response.data.list.data;
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .box-card {
    text-align: center;
    .value {
      color: #546DFE;
      font-weight: bold;
      font-size: 26px;
    }
    .subtitle {
      font-size: 12px;
      color: gray;
      margin-top: 6px;
    }
  }
</style>
